<div class="settings-container">
  <div class="sidebar setting-tabs-container flex justify-center">
    <ddc-tabs-chips
      [tabs]="[
        { key: 'profile', label: 'Profile', icon: 'person', selected: activeSection === 'profile' },
        { key: 'account', label: 'Account', icon: 'settings', selected: activeSection === 'account' },
        {
          key: 'billing-and-plans',
          label: 'Billing and plans',
          icon: 'payment',
          selected: activeSection === 'billing-and-plans',
        },
      ]"
      [theme]="_isLightTheme ? 'light' : _isDarkTheme ? 'dark' : 'paper'"
      (tabClick)="navigate($event)"
    ></ddc-tabs-chips>
  </div>

  <div class="content flex justify-center w-full">
    <ng-container [ngSwitch]="activeSection">
      <ddc-setting-profile
        class="w-full sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2"
        *ngSwitchCase="'profile'"
      ></ddc-setting-profile>
      <ddc-setting-account
        class="w-full sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2"
        *ngSwitchCase="'account'"
      ></ddc-setting-account>
      <ddc-setting-billing-and-plans
        class="w-full sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2"
        *ngSwitchCase="'billing-and-plans'"
      ></ddc-setting-billing-and-plans>
    </ng-container>
  </div>
</div>
